import Swiper from 'swiper/bundle'
import 'swiper/css'

const swiper = new Swiper('.js-product-slider', {
    slidesPerView: 1,
    spaceBetween: 15,
    scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true
    },
    breakpoints: {
      // when window width is >= 480px
      700: {
        slidesPerView: 2,
      },
      // when window width is >= 640px
      1000: {
        slidesPerView: 4,
      }
    }
})